import React, { Component } from 'react'
import Logo from '../images/logo.svg'
import {FaAlignRight} from 'react-icons/fa'
import {Link} from 'react-router-dom'

export default class Navbar extends Component {
    state={
        isOpen:false
    }
    handelToggel = ()=>{
        this.setState({isOpen:!this.state.isOpen})
    }

    render() {
        return (
            <nav>
                <div className="nav-center">
                    <div className="nav-header">
                        <Link to="/">
                            <img src={Logo} alt="logo" />
                        </Link>
                        <button type="button" className="nav-btn" onClick={this.handelToggel}>
                                <FaAlignRight className="nav-icon"/>
                        </button>
                    </div>
                    <ul className={this.state.isOpen?"nav-links show-nav":"nav-links"}>
                        <li>
                            <Link to="/" >Home</Link>
                        </li>
                        <li>
                            <Link to="/rooms" >Room</Link>
                        </li>
                    </ul>
                </div>
            </nav>
        )
    }
}
